import { render, staticRenderFns } from "./CustomerCustomInfoEditor.vue?vue&type=template&id=3e4f0ed3&scoped=true"
import script from "./CustomerCustomInfoEditor.vue?vue&type=script&lang=js"
export * from "./CustomerCustomInfoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4f0ed3",
  null
  
)

export default component.exports